import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class UtilityUpdation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      utilityList: [],
    };
  }

  async componentDidMount() {
    const staticData = [
      {
        id: 1,
        title: "ABC",
        description: "ABC",
      },
      {
        id: 2,
        title: "ABC1",
        description: "ABC1",
      },
      {
        id: 3,
        title: "ABC2",
        description: "ABC2",
      },
      {
        id: 4,
        title: "ABC3",
        description: "ABC3",
      },
      {
        id: 5,
        title: "ABC4",
        description: "ABC4",
      },
    ];

    this.setState({ utilityList: staticData });
  }

  onChangeField = (e, index, fieldName) => {
    const { utilityList } = this.state;
    utilityList[index][fieldName] = e.target.value;
    this.setState({ utilityList });
  };

  onUpdate = (item) => {
    const { showNotification } = this.props;

    console.log("item:", item);

    showNotification({
      msg: "Updated Successfully!",
      severity: "success",
    });
  };

  render() {
    const { utilityList } = this.state;

    return (
      <>
        <Paper sx={{ p: 2, borderRadius: 2 }} elevation={0}>
          <LandingScreenHeader
            screenTitle={"Utility Updation"}
            showAddButton={false}
          />

          <br></br>

          <Grid container spacing={2}>
            {utilityList?.map((item, index) => (
              <Grid
                item
                xs={12}
                key={item.id}
                container
                spacing={2}
                style={{
                  borderBottom: "1px solid #d1d1d1",
                  paddingBottom: 12,
                  marginBottom: 12,
                }}
              >
                {/* Title */}
                <Grid item xs={12} md={4}>
                  <LabelCompo label="Title :" />
                  <TextFieldCompo
                    name={"title" + item.id}
                    value={item.title}
                    fullWidth
                    onChange={(e) => this.onChangeField(e, index, "title")}
                  />
                </Grid>

                {/* Description */}
                <Grid item xs={12} md={6}>
                  <LabelCompo label="Description :" />
                  <TextFieldCompo
                    name={"description" + item.id}
                    value={item.description}
                    fullWidth
                    multiline
                    rows={2}
                    onChange={(e) =>
                      this.onChangeField(e, index, "description")
                    }
                  />
                </Grid>

                {/* Update button */}
                <Grid
                  item
                  xs={12}
                  md={2}
                  container
                  alignItems="center"
                  justifyContent="center"
                >
                  <ButtonCompo
                    size="small"
                    type="button"
                    variant="outlined"
                    name="Update"
                    onClick={() => this.onUpdate(item)}
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showLoador,
  showNotification,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(UtilityUpdation);
